<template>
  <pt-taxation-project-manage class="pt-taxation-project-manage__page"></pt-taxation-project-manage>
</template>

<script>
import PtTaxationProjectManage from 'cps/finance-manage/pt-taxation-project-manage/withData'
export default {
  name: 'pt-taxation-project-manage__view',
  components: {
    'pt-taxation-project-manage': PtTaxationProjectManage
  }
}
</script>
